import React from 'react';
import {NeuroMessage} from "@ignitesales/neuro-application";
import classnames from "classnames";
import MemberIcons from "./MemberIcons";

const BasicFooter = ({ className }) => {
    const componentClass = "basicFooter";
    const classes = classnames('footer', componentClass, className);

    return <footer className={classes}>
        <div className="container">
            <div className={`${componentClass}__copyright`}>
                <NeuroMessage id="footer.copyright" tagName="span" values={{year: (new Date()).getFullYear()}}/>
            </div>
            <NeuroMessage id="footer.privacyPolicy" tagName="span" className="privacy-policy" shouldHideIfNotFound={true} />
            <MemberIcons className='icon-container' />
        </div>
    </footer>
};

export default BasicFooter;
